import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { CommonModalComponent } from "./../Pages/Modals/common-modal/common-modal.component";
import { BroadcastService } from "../Helpers/broadcast.service";
import { CrudService } from "../Services/crud.service";

import { Injectable } from "@angular/core";
enum Event {
  LogIN,
}

@Injectable({
  providedIn: "root", // or omit to provide in module providers
})
export class Utils {
  closeResult: string;
  modalRef: any;
  isRegisterBroadcastEvent;
  data;

  constructor(
    public modalService: NgbModal,
    private broadcastService: BroadcastService<Event>,
    private crudService: CrudService
  ) {}

  ngOnInit() {
    alert("test");
  }

  openLogInPopup(requestData) {
    this.modalRef = this.modalService.open(CommonModalComponent, {
      size: "sm",
      backdrop: "static",
      keyboard: false,
    });
    this.data = requestData;

    // register broadcast service
    if (!this.isRegisterBroadcastEvent) {
      this.isRegisterBroadcastEvent = true;
      this.broadcastService
        .GetEvent(Event.LogIN.toString())
        .subscribe((eventData) => {
          this.closeLogInPopup();
          // also keep check that if user has opted for the re-summit the data after success login
          if (eventData["response"] === "Success") {
            this.reSubmitRequest();
          }
        });
    }
  }

  closeLogInPopup() {
    if (this.modalRef) this.modalRef.close();
  }

  reSubmitRequest() {
    let requestData = this.data;
    if (requestData) {
      switch (requestData.method) {
        case "GET":
          this.crudService.get(
            null,
            function (response) {
              // callback for the different workflow
            },
            requestData.urlWithParams
          );
          break;
        case "POST":
          this.crudService.post(
            requestData.body,
            function (response) {
              // callback for the different workflow
            },
            requestData.urlWithParams
          );
          break;
        case "PUT":
          this.crudService.update(
            requestData.body,
            function (response) {
              // callback for the different workflow
            },
            requestData.urlWithParams
          );
          break;
        case "DELETE":
          this.crudService.delete(
            null,
            function (response) {
              // callback for the different workflow
            },
            requestData.urlWithParams
          );
          break;
        default:
      }
    }
  }
}
